
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Onewaycabpune() {



    const cardData =
    {
        keyword: 'One Way Cab Pune',
        heading: 'Meghana Cab : One Way Cab Pune',
        headingDescription: 'Meghana Cab offers One Way Cab Pune services, providing a convenient and budget-friendly solution for single-route travel. Whether you are heading to a nearby city, airport, or returning home after a visit, our one-way cab service is designed to save you time and money. Choose from a range of well-maintained vehicles with professional drivers ensuring a safe and smooth ride. Enjoy transparent pricing, flexible scheduling, and 24/7 support. Book your One Way Cab in Pune with Meghana Cab for a smart and stress-free travel experience.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "A historic fortification in the heart of Pune, Shaniwar Wada was built in 1732 by the Peshwas of the Maratha Empire. Once the seat of power, this grand palace is known for its majestic gates, ruined structures, and haunting legends. The evening light and sound show offers an engaging retelling of its rich history. 🌆"
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, this magnificent palace played a significant role during India’s freedom movement. Mahatma Gandhi and Kasturba Gandhi were imprisoned here. The palace features Italian arches, sprawling gardens, and a museum dedicated to Gandhi’s legacy. 🕊️"
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop a hill, Sinhagad Fort offers panoramic views and a glimpse into Maratha history. Famous for the Battle of Sinhagad (1670), it honors the bravery of Tanaji Malusare. Trekkers often enjoy local dishes like pithla bhakri at the summit. 🏞️"
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "A treasure trove of Indian art and antiques, this museum houses over 20,000 artifacts, including musical instruments, weaponry, and everyday items from different Indian eras. It gives a vivid insight into India’s artistic heritage. 🏺"
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It features a sanctum with a Shiva lingam and intricately carved pillars—offering a serene spiritual experience in the heart of Pune. 🕉️"
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A peaceful retreat just outside the city, this dam is popular for its breezy environment and lakeside picnics. Locals enjoy evening strolls, tea stalls, and breathtaking views of the water surrounded by hills. 🌊"
  },
  {
    "title": "Fergusson College Road",
    "description": "A bustling street lined with cafes, bookstores, fashion outlets, and snack vendors. Loved by students and youth, it’s perfect for exploring Pune’s urban culture, trendy hangouts, and lively street food. ☕"
  },
  {
    "title": "Osho Garden & Meditation Resort",
    "description": "Located in Koregaon Park, this tranquil oasis offers meditation sessions, wellness therapies, and lush gardens. Attracting global visitors, it’s ideal for those seeking peace, reflection, or a mindful experience. 🌿"
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this landscaped paradise features bridges, koi ponds, and manicured lawns. It's one of Pune's most peaceful parks—ideal for walks, photography, and family outings. 🌸"
  },
  {
    "title": "Lal Mahal",
    "description": "Built by Shahaji Bhosale in the 1630s, this red palace was home to Chhatrapati Shivaji Maharaj in his early years. Today, it houses paintings and exhibits related to his life and remains a symbol of pride for Pune. 🏰"
  }
],

"services": [
    {
        "name": "One Way Cab Service Pune",
        "description": "Book reliable and convenient one way cab services from Pune with Meghana Cab. Perfect for travelers needing a seamless point-to-point ride without return obligations."
    },
    {
        "name": "Affordable One Way Cabs from Pune",
        "description": "Travel affordably with Meghana Cab’s budget-friendly one way cabs from Pune, ensuring great service without compromising on comfort or safety."
    },
    {
        "name": "Book One Way Taxi Online Pune",
        "description": "Easily book your one way taxi online in Pune through Meghana Cab’s hassle-free digital platform with instant confirmation and trusted drivers."
    },
    {
        "name": "Intercity One Way Cab Pune",
        "description": "Travel between cities effortlessly with Meghana Cab’s intercity one way cab service, covering popular routes with punctual and comfortable rides."
    },
    {
        "name": "Pune to Mumbai One Way Taxi",
        "description": "Enjoy a smooth and timely one way taxi ride from Pune to Mumbai with Meghana Cab, featuring well-maintained vehicles and professional chauffeurs."
    },
    {
        "name": "Pune to Nashik One Way Cab",
        "description": "Book your Pune to Nashik one way cab with Meghana Cab for a comfortable and stress-free journey to this wine country and pilgrimage destination."
    },
    {
        "name": "Pune to Aurangabad One Way Ride",
        "description": "Travel conveniently from Pune to Aurangabad one way with Meghana Cab, perfect for visiting historical sites like Ajanta and Ellora Caves."
    },
    {
        "name": "Budget One Way Trips Pune",
        "description": "Opt for budget-friendly one way trips from Pune with Meghana Cab, providing affordable rates without compromising on quality service."
    },
    {
        "name": "Pune to Goa One Way Car Rental",
        "description": "Plan your one way trip from Pune to Goa with Meghana Cab’s car rental services, enjoying scenic drives and comfortable vehicles."
    },
    {
        "name": "Fast Booking One Way Cab Pune",
        "description": "Book one way cabs quickly in Pune with Meghana Cab’s efficient booking system designed for last-minute and planned travel."
    },
    {
        "name": "Chauffeur Cab One Way from Pune",
        "description": "Hire professional chauffeurs for your one way cab rides from Pune with Meghana Cab, ensuring safety, professionalism, and friendly service."
    },
    {
        "name": "One Side Taxi Pune Airport",
        "description": "Get hassle-free one side taxi services from Pune Airport with Meghana Cab, perfect for airport drop-offs and pickups without return trips."
    },
    {
        "name": "Pune to Ahmednagar One Way Cab",
        "description": "Travel comfortably one way from Pune to Ahmednagar with Meghana Cab, offering well-maintained cars and reliable drivers."
    },
    {
        "name": "Low Fare One Way Cabs Pune",
        "description": "Avail low fare one way cabs in Pune from Meghana Cab, combining affordability with quality and timely services."
    },
    {
        "name": "Outstation One Way Travel Pune",
        "description": "Book outstation one way travel from Pune with Meghana Cab for long-distance journeys, ensuring comfort and safety on the road."
    }
],

"tableData": [
    ["One Way Cab Service Pune", "Affordable One Way Cabs from Pune"],
    ["Book One Way Taxi Online Pune", "Intercity One Way Cab Pune"],
    ["Pune to Mumbai One Way Taxi", "Pune to Nashik One Way Cab"],
    ["Pune to Aurangabad One Way Ride", "Budget One Way Trips Pune"],
    ["Pune to Goa One Way Car Rental", "Fast Booking One Way Cab Pune"],
    ["Chauffeur Cab One Way from Pune", "One Side Taxi Pune Airport"],
    ["Pune to Ahmednagar One Way Cab", "Low Fare One Way Cabs Pune"],
    ["Outstation One Way Travel Pune", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Convenient One Way Cab Service in Pune",
        "WhyChoosedescription": "Meghana Cab offers reliable and affordable one way cab services from Pune to various destinations. Perfect for travelers who don’t need a return trip, our service ensures comfort and convenience at great rates."
    },
    {
        "WhyChooseheading": "Pay Only for One Side – No Return Fare",
        "WhyChoosedescription": "With Meghana Cab’s one way cab Pune service, you only pay for the distance you travel. No need to pay extra for a round trip when you only need a one-way ride."
    },
    {
        "WhyChooseheading": "Wide Coverage of Cities and Routes",
        "WhyChoosedescription": "Our one way cab services cover a wide range of destinations from Pune including Mumbai, Nashik, Lonavala, Kolhapur, Aurangabad, and more. We make intercity travel easy and economical."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy clear and upfront pricing with no hidden charges. Meghana Cab provides budget-friendly one way cab options with complete transparency on fare details."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "All our cabs are clean, sanitized, and regularly serviced. Travel in comfort and safety in vehicles equipped with air conditioning, seat belts, and GPS tracking."
    },
    {
        "WhyChooseheading": "Professional Drivers for a Safe Journey",
        "WhyChoosedescription": "Our experienced drivers ensure a smooth and secure journey. They are trained for intercity travel and prioritize customer safety and satisfaction throughout the trip."
    },
    {
        "WhyChooseheading": "24/7 One Way Cab Availability",
        "WhyChoosedescription": "Need a ride early in the morning or late at night? Meghana Cab offers round-the-clock one way cab services from Pune to suit your schedule and travel plans."
    },
    {
        "WhyChooseheading": "Easy Booking and Support",
        "WhyChoosedescription": "Book your one way cab from Pune quickly through our website or app. Our friendly customer support team is available to assist you with bookings and travel-related queries anytime."
    }
]

























    }

const faqData = [
    {
        question: "How can I book a one-way cab in Pune with Meghana Cab?",
        answer: "Booking a one-way cab in Pune is simple with Meghana Cab. You can book online on our website or call us at +91 9075462128."
    },
    {
        question: "What vehicle options are available for one-way cab services in Pune?",
        answer: "We offer hatchbacks, sedans, SUVs, and tempo travellers to accommodate your one-way travel needs."
    },
    {
        question: "Is the one-way cab service available for local and outstation trips?",
        answer: "Yes, Meghana Cab provides one-way cab services both within Pune city and for outstation destinations."
    },
    {
        question: "Are tolls and taxes included in the one-way cab fare?",
        answer: "Toll, parking, and applicable taxes are additional and communicated clearly during the booking process."
    },
    {
        question: "Can I book a one-way cab on short notice?",
        answer: "Yes, subject to vehicle availability, you can book a one-way cab even at short notice."
    },
    {
        question: "Are Meghana Cab drivers experienced and professional?",
        answer: "Absolutely! Our drivers are trained, experienced, and committed to providing safe and comfortable rides."
    },
    {
        question: "Is the one-way cab service available 24/7 in Pune?",
        answer: "Yes, Meghana Cab operates 24/7, so you can book your one-way cab anytime."
    },
    {
        question: "What payment methods are accepted for one-way cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments for your convenience."
    },
    {
        question: "Can I request stops during a one-way trip?",
        answer: "Yes, you can request stops along the way. Please inform us at the time of booking."
    },
    {
        question: "How do I contact Meghana Cab for one-way cab bookings in Pune?",
        answer: "You can contact Meghana Cab at +91 9075462128 for bookings and support."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Sanjay Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I booked a one-way cab with Meghana Cab in Pune and had a smooth and comfortable ride. The driver was professional and punctual.”',
    },
    {
        name: 'Ms. Anjali Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab’s one-way cab service in Pune is reliable and affordable. I highly recommend their service.”',
    },
];



















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Way Cab Pune",
  "image": "https://www.meghanacabs.com/assets/images/one-way-cab-pune.jpg",
  "description": "Book affordable one way cab service from Pune with Meghana Cabs. Reliable and quick taxi booking for intercity trips including Mumbai, Nashik, Aurangabad, Goa, and more.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5302"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/one-way-cab-pune"
  }
};






    return (
        <div>


<Helmet>
  <title>One Way Cab Pune | Affordable & Reliable One Way Taxi | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book affordable one way cab service from Pune with Meghana Cabs. Reliable and quick taxi booking for intercity trips including Mumbai, Nashik, Aurangabad, Goa, and more." 
  />
  <meta 
    name="keywords" 
    content="One Way Cab Service Pune, Affordable One Way Cabs from Pune, Book One Way Taxi Online Pune, Intercity One Way Cab Pune, Pune to Mumbai One Way Taxi, Pune to Nashik One Way Cab, Pune to Aurangabad One Way Ride, Budget One Way Trips Pune, Pune to Goa One Way Car Rental, Fast Booking One Way Cab Pune, Chauffeur Cab One Way from Pune, One Side Taxi Pune Airport, Pune to Ahmednagar One Way Cab, Low Fare One Way Cabs Pune, Outstation One Way Travel Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/13.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Onewaycabpune;